import { trimValue } from '../common/helper';
import { formatDate } from '../common/datetime/FormattedDateTime';
import React from 'react';
import { Link } from 'react-router';
import {
  InternalApiPersonScreeningAuditEvent,
  InternalApiPersonStatusEvent,
  InternalApiSanctionCheckEvent,
  InternalApiSnoozeEvent,
  InternalApiSnoozeEventEventTypeEnum,
} from '../api-internal';
import { ContentPreviewer } from '../common/ContentPreviewer';

interface StatusInformationProps {
  statusEvent: InternalApiPersonStatusEvent;
  index: number;
  length: number;
}

export const getStatusInformation = ({ statusEvent, index, length }: StatusInformationProps): string => {
  return index === length - 1
    ? `Initial status: ${statusEvent.status.status}`
    : statusEvent.assigner != null
      ? `${statusEvent.assigner.name} set status to: ${statusEvent.status.status}`
      : `Status changed to: ${statusEvent.status.status}`;
};

export const getSnoozeEventInformation = (event: InternalApiSnoozeEvent) => {
  const user = event.snoozeConfig.createdBy ? event.snoozeConfig.createdBy.name : 'System';
  const action =
    event.eventType === InternalApiSnoozeEventEventTypeEnum.CREATE
      ? 'snoozed'
      : event.eventType === InternalApiSnoozeEventEventTypeEnum.DELETE
        ? 'resumed'
        : '';

  const subject = event.snoozeConfig.scenarioReason
    ? `scenario "${trimValue(event.snoozeConfig.scenarioReason, 50, true)}"`
    : 'all alerts';

  const actionLabel = `${action} ${subject}`;

  const displayAdditionalInfo = () => {
    if (event.eventType === InternalApiSnoozeEventEventTypeEnum.CREATE) {
      const until = event.snoozeConfig.endTime ? `until ${formatDate(event.snoozeConfig.endTime)}` : '';
      const total = event.snoozeConfig.totalAmount ? ` for total amount of ${event.snoozeConfig.totalAmount}` : '';
      return `${until}${total}`;
    } else {
      return '';
    }
  };

  return event.eventType === InternalApiSnoozeEventEventTypeEnum.UPDATE
    ? `Snooze configuration amount updated: ${event.snoozeConfig.amount} of ${event.snoozeConfig.totalAmount}`
    : `${user} ${actionLabel} ${displayAdditionalInfo()}`;
};

export const SnoozeNotePreview = ({ event }: { event: InternalApiSnoozeEvent }) => {
  return (
    event.snoozeConfig.note &&
    event.eventType !== InternalApiSnoozeEventEventTypeEnum.DELETE && (
      <ContentPreviewer>{event.snoozeConfig.note}</ContentPreviewer>
    )
  );
};

export const ScreeningCheckMatch = ({ event }: { event: InternalApiSanctionCheckEvent }) => {
  return (
    <div className={'text-s'}>
      {event.sanctionAlertId ? (
        <Link to={`/screening/alerts/${event.sanctionAlertId}`}>Match found</Link>
      ) : (
        'No match found'
      )}
    </div>
  );
};

export const ScreeningAuditEventDescription = ({ flow }: { flow: InternalApiPersonScreeningAuditEvent }) => {
  return (
    <>
      <div>Start: {formatDate(flow.startTime, true)}</div>
      <div>End: {flow.endTime ? formatDate(flow.endTime, true) : '-'}</div>
    </>
  );
};
